var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiciosIndustriaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5622 16.9643C18.5622 17.4576 18.1627 17.8571 17.6694 17.8571H12.3122C11.8189 17.8571 11.4194 17.4576 11.4194 16.9643V14.2857H0.705078V22.3214C0.705078 23.75 1.95508 25 3.38365 25H26.5979C28.0265 25 29.2765 23.75 29.2765 22.3214V14.2857H18.5622V16.9643ZM26.5979 5.35714H22.1337V2.67857C22.1337 1.25 20.8836 0 19.4551 0H10.5265C9.09794 0 7.84794 1.25 7.84794 2.67857V5.35714H3.38365C1.95508 5.35714 0.705078 6.60714 0.705078 8.03571V12.5H29.2765V8.03571C29.2765 6.60714 28.0265 5.35714 26.5979 5.35714ZM18.5622 5.35714H11.4194V3.57143H18.5622V5.35714Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiciosIndustriaIcon);
export default __webpack_public_path__ + "static/media/servicios_industria_icon.4937cabbd5251358707dc6c8f732a9f9.svg";
export { ForwardRef as ReactComponent };